import { connect } from 'react-redux';
import type { UserSelectorState } from '@peloton/auth/redux';
import type { ExtLinkEnvState } from '@peloton/external-links/redux';
import { toMapStateToLinkProps } from '@peloton/external-links/withExtHrefs';
import { Links } from '@peloton/links';
import { orderHistoryAccount } from '@peloton/links/account';
import { track as trackAction } from '@engage/analytics/actions';
import type { ReferralSelectorState } from '@members/referrals/redux';
import { getReferralEligibility } from '@members/referrals/redux';
import { Source } from '../../../../stacks/analytics/events';
import { openMemberSearchFromNav } from '../MemberSearchFromNav';
import { openNotificationsFromNav } from '../NotificationsFromNav';
import { openStackFromNav } from '../StackFromNav';
import { MobileNavDrawerView } from './MobileNavDrawerView';
import type { StateProps, DispatchProps, OwnProps } from './types';

// Re-export types for backwards compatibility
export type { MobileNavViewProps } from './types';

const mapStateToLinkProps = toMapStateToLinkProps({
  boutiqueHref: Links.boutique,
  supportHref: Links.support,
  orderHistoryHref: Links.orderhistory,
  orderHistoryAccountHref: orderHistoryAccount,
});

type SelectorState = ExtLinkEnvState & ReferralSelectorState & UserSelectorState;

export const MobileNavDrawer = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  SelectorState
>(
  state => ({
    ...mapStateToLinkProps(state),
    canRefer: getReferralEligibility(state),
  }),
  {
    handleSearchClick: openMemberSearchFromNav,
    track: trackAction,
    handleStackClick: () => openStackFromNav(Source.Navigation),
    handleNotificationsClick: () => openNotificationsFromNav(Source.Navigation),
  },
)(MobileNavDrawerView);
